import React, { useContext } from "react";
import styled from "styled-components";
import Stat from "./Stat";
import { CATS as OPTA_CATS } from "../../Graphics/BasicPack/PlayerStats";
import { ScrollBar } from "../../Theme/Hyper";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { UIContext } from "../../contexts/UIContext";

const Main = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  font-size: 0.8em;
  max-height: 40vh;
  overflow-y: auto;
`;
const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 1em;
  font-weight: 100;
  align-items: center;
`;

export default function OptaSelectedPlayerStats({ game, player }) {
  const { previewGraphic } = useContext(GraphicsContext);
  const { periods } = useContext(UIContext);
  const isHome = player?.team?._id === game?.home_team?._id;
  const playerStats = (
    isHome ? game?.opta_player_stats?.home : game?.opta_player_stats?.away
  )?.find((p) => p?.player === player?.opta_ID);

  let period = {};
  if (periods?.length > 0) {
    period = periods?.sort((a, b) => b.number - a.number)?.[0];
  }

  return (
    <Main>
      {OPTA_CATS.map((cat) => (
        <Row key={cat.title}>
          <Stat
            game={game}
            single
            category={cat.title}
            stat={{
              home: cat?.calc({ stats: playerStats?.stats }) || 0,
            }}
            onCategoryClick={() => {
              previewGraphic("PlayerStats", {
                player,
                team: player?.team,
                game,
                customStatTitle: cat.title,
                customStatValue: cat?.calc({ stats: playerStats?.stats }),
                customStatType: "Clock",
                period,
              });
            }}
          />
        </Row>
      ))}
    </Main>
  );
}
